<template>
  <section class="container">
    <div class="row justify-content-between">
      <div class="col-lg-7 col-xl-8 col-sm-12">
        <div class="step-form__main">
          <!-- <h1 class="bluefont">Choose the loan product you would like to apply for</h1> -->
          <h1 class="bluefont">Fast application. simple process. fast funding.</h1>
          <p/>
          <h5>
            Already have an account? &nbsp;&nbsp;
            <a href="/login">Sign In</a>
          </h5>
          <p/>
          <br/>
          <el-form class="step-form__form" :model="ctlForm" :rules="rules" ref="ctlForm">
            <el-row :gutter="0">
              <el-col :span="16">
                <el-form-item label="Which loan would you like to apply for?" prop="product" required>
                  <el-select v-model="ctlForm.product" v-on:change="onProductChange" placeholder class="select_width">
                    <el-option
                      class="custom-el-option"
                      v-for="item in productS"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="What is the amount you would like? ($20,000 - $5,000,000)" prop="amount" required>
                  <el-input type="number" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                            v-model="ctlForm.amount">
                    <template slot="prepend">$</template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="ctlForm.product === '10000057823975'" label="Desired loan term" prop="term"
                              :required="ctlForm.product === '10000057823975'">
                  <el-select v-model="ctlForm.term" placeholder class="select_width">
                    <el-option
                      class="custom-el-option"
                      v-for="item in equipmentLoanTermS"
                      :key="item.value"
                      :label="item.text.concat(' months')"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="ctlForm.product === '10000057880003'" label="Desired loan term" prop="term"
                              :required="ctlForm.product === '10000057880003'">
                  <el-select v-model="ctlForm.term" placeholder class="select_width">
                    <el-option
                      class="custom-el-option"
                      v-for="item in invoiceFinancingTermS"
                      :key="item.value"
                      :label="item.text.concat(' days')"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email" ref="email" required>
                  <el-input
                    type="email"
                    placeholder="Email address"
                    v-model="ctlForm.email"
                    :maxlength="50"
                    @change="allowSendingVerifyCode"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Password" prop="registerPassword" ref="registerPassword" required>
                  <el-input
                    type="password"
                    placeholder="Password"
                    v-model="ctlForm.registerPassword"
                    :minlength="8"
                    :maxlength="16"
                    @change="allowSendingVerifyCode"
                    @blur="inputBlurFn('registerPassword')"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Confirm password" prop="confirmRegisterPassword" ref="confirmRegisterPassword"
                              required>
                  <el-input
                    type="password"
                    placeholder="Confirm password"
                    v-model="ctlForm.confirmRegisterPassword"
                    :maxlength="16"
                    @change="allowSendingVerifyCode"
                    @blur="inputBlurFn('confirmRegisterPassword')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="SMSVerificationCode">
              <el-row>
                <el-input
                  type="number"
                  placeholder="Email verification code"
                  v-model="ctlForm.SMSVerificationCode"
                  :disabled="isAllowSendingVerifyCode"
                  :maxlength="6"
                ></el-input>
                <el-button
                  type="primary"
                  size="mini"
                  class="user-operation__sms-button lightbluebg"
                  style="margin-right:5px;margin-top:2px;"
                  :loading="isLoadingCode"
                  :disabled="SMSVerificationCodeBtn.disabled"
                  @click="getSMSVerificationCode"
                >{{ SMSVerificationCodeBtn.text }}
                </el-button>
              </el-row>
            </el-form-item>
          </el-form>

          <div style="font-family: lato;">
            <h4>CONSENTS</h4>By clicking the SUBMIT button below and continuing with the
            application process, you understand and agree that you are
            providing written instructionsto American Credit, Inc.
            under the Fair Credit Reporting Act authorizing American Credit,
            Inc., a California Licensed Lender, to obtain information from
            your business and personal credit profile or other information
            from one or more consumer reporting agencies, such as Experian,
            TransUnion, and Equifax. You authorize American Credit, Inc to
            obtain such information solely to conduct a credit-worthiness
            evaluation for credit options on any loan products offered by
            American Credit, Inc
          </div>

          <div class="step-form__btn-container">
            <el-button
              type="primary"
              :loading="isLoading"
              class="bluebg rounded-pill font-weight-bold px-4"
              @click="submitRegisterForm"
            >SUBMIT
            </el-button>
            <br/>
            <br/>
            <br/>
          </div>
        </div>
        <div></div>
      </div>
      <div class="col col-lg-5 col-xl-3 d-flex flex-column justify-content-between my-5 my-lg-0">
        <div class="col flex-column align-items-center">
          <img src="../../assets/imgs/corey.png" class="d-block mx-auto mt-lg-4"
               alt="Corey Photo"/>
          <span class="consultant-name my-3 d-block">Corey Rockafeler, Loan Manager</span>
          <p class="text-center consultant-quote">“Everyday, we empower entrepreneurs and business owners to live the American Dream. Fast, simple, and
            convenient business lending at your fingertips.” </p>
          <div class="phone-info text-center"><span class="phone-icon fa fa-phone mr-2"></span>Sales: <a href="tel:8559040188">855-904-0188</a></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import placeholders from '../../scripts/placeholders'
import api from '../../vuex/api'
import Cookie from 'js-cookie'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as types from '../../vuex/types'
import axios from 'axios'

export default {
  data () {
    const assignValidator = (type, trigger = 'blur') =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            })
          }
        }
      )
    return {
      pickerOptions1: {
        /*disabledDate(time) {
					  return time.getTime() < Date.now() - 8.64e7;
					}*/
      },
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: '',
      screenHeight: document.body.clientHeight,
      isApplyFirst: true,
      countDown: '',
      isRegistering: false,
      isRegistered: false,
      publicKey: '',
      isAllowSendingVerifyCode: true,
      isLoadingCode: false,
      SMSVerificationCodeBtn: {
        disabled: true,
        text: 'get email verification code'
      },
      isLoading: false,
      isCounting: false,
      rules: {
        product: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              console.log('product')
              if (_.trim(value) === '') {
                callback(new Error('Product can not be empty'))
              } else {
                callback()
              }
            }
          }
        ],
        amount: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              console.log('amount')
              if (_.trim(value) === '') {
                // if (value.includes("e") || value.includes("E")) {
                //   callback(new Error("Input format E error"));
                // } else {
                callback(new Error('Amount can not be empty'))
                // }
                // } else if (!/^[0-9]*$/.test(value)) {
                //   callback(new Error("Input format error"));
              } else if (value < 20000) {
                callback(new Error('Minimum loan amount is $20,000'))
              } else if (value > 5000000) {
                callback(new Error('Maximum loan amount is $5,000,000'))
              } else {
                callback()
              }
            }
          }
        ],
        term: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              console.log('term')
              if (_.trim(value) === '') {
                callback(new Error('Term can not be empty'))
              } else {
                callback()
              }
            }
          }
        ],
        email: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('Email can not be empty.'))
              } else {
                callback()
              }
            }
          }
        ],
        registerPassword: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('Password can not be empty.'))
              } else {
                callback()
              }
            }
          }
        ],
        confirmRegisterPassword: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('Confirm password can not be empty.'))
              } else if (value !== this.ctlForm.registerPassword) {
                callback(new Error('Password and confirm password are inconsistencies'))
              } else {
                callback()
              }
            }
          }
        ],
        // firstName: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("Business name can not be empty."));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ],

        // streetAddress: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("Street Address1 can not be empty."));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ],
        // cityName: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("City can not be empty"));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ],
        // zipCode: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("Zip code can not be empty"));
        //       }else if (_.trim(value).length != 5 ) {
        //         callback(new Error("Zip code must be 5 digital"));
        //       }else if (!/^[0-9]*$/.test(value)) {
        //         callback(new Error("Input error"));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ],
        // state: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("State can not be empty"));
        //       } else {
        //         callback();
        //       }
        //     }
        //   }
        // ],

        // phone: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("Business phone can not be empty"));
        //       }else if (_.trim(value).length != 10 ) {
        //         callback(new Error("Business phone must be 10 digital"));
        //       }
        //       else {
        //         callback();
        //       }
        //     }
        //   }
        // ],
        // tin: [
        //   {
        //     require: true,
        //     trigger: "blur",
        //     validator: (rules, value, callback) => {
        //       if (_.trim(value) === "") {
        //         callback(new Error("EIN can not be empty"));
        //       }else if (_.trim(value).length != 9 ) {
        //         callback(new Error("TIN must be 9 digital"));
        //       }
        //       else {
        //         callback();
        //       }
        //     }
        //   }
        // ],
        SMSVerificationCode: [
          {
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('Verification code can not be empty'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      productS: [
        {value: '10000057823975', text: 'Equipment loan'},
        {value: '10000057880003', text: 'Invoice financing'}
        // { value: "10000058170080", text: "Paycheck protection" }
      ],
      amountS: [
        {value: '20000', text: '$20,000'},
        {value: '30000', text: '$30,000'},
        {value: '40000', text: '$40,000'},
        {value: '50000', text: '$50,000'},
        {value: '60000', text: '$60,000'},
        {value: '70000', text: '$70,000'},
        {value: '80000', text: '$80,000'},
        {value: '90000', text: '$90,000'},
        {value: '100000', text: '$100,000'},
        {value: '150000', text: '$150,000'},
        {value: '200000', text: '$200,000'},
        {value: '250000', text: '$250,000'},
        {value: '300000', text: '$300,000'},
        {value: '350000', text: '$350,000'},
        {value: '400000', text: '$400,000'},
        {value: '450000', text: '$450,000'},
        {value: '500000', text: '$500,000'},
        {value: '550000', text: '$550,000'},
        {value: '600000', text: '$600,000'},
        {value: '650000', text: '$650,000'},
        {value: '700000', text: '$700,000'},
        {value: '750000', text: '$750,000'},
        {value: '800000', text: '$800,000'},
        {value: '850000', text: '$850,000'},
        {value: '900000', text: '$900,000'},
        {value: '950000', text: '$950,000'},
        {value: '1000000', text: '$1,000,000'},
        {value: '1500000', text: '$1,500,000'},
        {value: '2000000', text: '$2,000,000'},
        {value: '2500000', text: '$2,500,000'},
        {value: '3000000', text: '$3,000,000'},
        {value: '3500000', text: '$3,500,000'},
        {value: '4000000', text: '$4,000,000'},
        {value: '4500000', text: '$4,500,000'},
        {value: '5000000', text: '$5,000,000'}
      ],
      equipmentLoanTermS: [
        {value: '1', text: '1'},
        {value: '2', text: '2'},
        {value: '3', text: '3'},
        {value: '4', text: '4'},
        {value: '5', text: '5'},
        {value: '6', text: '6'},
        {value: '7', text: '7'},
        {value: '8', text: '8'},
        {value: '9', text: '9'},
        {value: '10', text: '10'},
        {value: '11', text: '11'},
        {value: '12', text: '12'},
        {value: '18', text: '18'},
        {value: '24', text: '24'},
        {value: '30', text: '30'},
        {value: '36', text: '36'},
        {value: '42', text: '42'},
        {value: '48', text: '48'},
        {value: '54', text: '54'},
        {value: '60', text: '60'},
        {value: '66', text: '66'},
        {value: '72', text: '72'}
      ],
      invoiceFinancingTermS: [
        {value: '15', text: '15'},
        {value: '30', text: '30'},
        {value: '45', text: '45'},
        {value: '60', text: '60'},
        {value: '75', text: '75'},
        {value: '90', text: '90'},
        {value: '105', text: '105'},
        {value: '120', text: '120'},
        {value: '135', text: '135'},
        {value: '150', text: '150'},
        {value: '165', text: '165'},
        {value: '180', text: '180'}
      ],
      stateS: [],
      titleData: [],
      mastateS: [],
      isEditable: 0,
      ctlForm: {
        product: '',
        amount: '',
        term: ''
        // firstName: "",
        // streetAddress: "",
        // streetAddress2: "",
        // cityName: "",
        // state: "",
        // zipCode: "",
        // phone: "",
        // tin: ""
      }
    }
  },
  computed: {
    ...mapGetters({
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      // userInfo: types.GET_USER,
      getRegisterContract: types.SET_REGISTER_CONTRACT,
      userLogin: types.USER_LOGIN,
      //userRegister: types.USER_REGISTER,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY,

      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE
    }),

    ...mapMutations({
      setUserInfo: types.SET_USER,
      setRegisterContract: types.SET_CONTRACT_STATE
    }),

    allowSendingVerifyCode (val) {
      if (this.isCounting === false) {
        this.isAllowSendingVerifyCode = val.trim() !== ''
        this.SMSVerificationCodeBtn = {
          disabled: val.trim() === '',
          text: 'get email verification code'
        }
      }
    },

    getMgxyGetPersonDetails () {
      //èŽ·å�–è¿›ä»¶ä¸ªäººä¿¡æ�¯
    },

    formatData (data) {
      var arr = []
      for (var key in data) {
        var obj = {}
        obj.value = data[key]
        obj.text = key
        arr.push(obj)
      }
      return arr
    },
    formatDataForSort (data) {
      var arr = []
      var arr2 = []
      for (var key in data) {
        arr[arr.length] = data[key]
      }
      arr.sort()
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {}
            obj.value = data[key]
            obj.text = key
            arr2.push(obj)
          }
        }
      }
      return arr2
    },

    inputBlurFn (prop) {
      if (event.srcElement) {
        this.ctlForm[prop] = event.srcElement.value
      }
    },

    getSMSVerificationCode () {

      // hubspot create new contact
      this.createOrUpdateHubspotContact('false');

      this.isLoadingCode = true
      //alert(321)
      // REGISTRATIONä¸Žå¿˜è®°å¯†ç �çš„çŸ­ä¿¡éªŒè¯�å€’è®¡æ—¶ä¸�éœ€è¦�å…±ç”¨ï¼Œéœ€è¦�å°±å°†ç›¸å…³æ“�ä½œæ‰”åŽ»actionï¼ŒçŽ°åœ¨è¿™æ ·å°±ç›´æŽ¥è¯·æ±‚ï¼Œé™�ä½Žå¤�æ�‚åº¦
      // debugger;
      api
        .getSMSVerificationCodeForEmailRegister({
          email: this.ctlForm.email,
          tokenId: this.userInfo.token
        })
        .then(res => {
          this.isAllowSendingVerifyCode = false
          const resData = res.data
          let countDownTime = 420
          if (Number(resData.code) === 0) {
            this.countDown = setInterval(() => {
              this.isLoadingCode = false
              this.isCounting = true
              countDownTime -= 1
              if (countDownTime !== 0) {
                this.SMSVerificationCodeBtn = {
                  disabled: true,
                  text: `Expire in ${countDownTime} seconds`
                }
              } else {
                this.SMSVerificationCodeBtn = {
                  disabled: false,
                  text: 'get email verification code'
                }
                clearInterval(this.countDown)
                this.isCounting = false
              }
            }, 1000)
          } else {
            this.isLoadingCode = false
            this.setAlertMessage({
              show: true,
              content: resData.result
            })
          }
        })
        .catch(error => {
          if (error) {
            this.isLoadingCode = false
          } else {
            this.isLoadingCode = false
          }
        })
    },

    showRegisterContract () {
      this.setRegisterContract({
        show: true
      })
    },

    getMgxyDictionary () {
      var _this = this
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0])
        _this.titleData = _this.formatData(res.data.result[7])
        _this.mastateS = _this.formatData(res.data.result[6])
      })
    },
    goBack () {
      this.saveApplyLoanProgress({
        router: this.$router,
        token: this.userInfo.token,
        id: this.$route.query.applyLoanId,
        step: 1
      }).then(res => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          this.$router.push({
            path: `/applyLoan/${this.$route.params.id}/sbl`,
            query: {
              applyLoanId: this.$route.query.applyLoanId,
              isEdit: true
            }
          })
        }
      })
    },

    onProductChange () {
      if(this.ctlForm.product === '10000057823975') {
        this.$router.push({
          path: `/get-start`,
        },() => {
          this.setSuccessMessage({
            show: true,
            content: "Please complete our new equipment loan application process, it only takes you 3-5 minites!"
          });
        })
      }
      console.log('reset loan')
      this.ctlForm.amount = ''
      this.ctlForm.term = ''
    },

    submitRegisterForm () {
      var _this = this
      this.$refs.ctlForm.validate(valid => {
        if (valid) {
          const form = this.ctlForm
          this.isRegistering = true
          const encrypt = new JSEncrypt()
          encrypt.setPublicKey(this.publicKey)
          const _registerPassword = encodeURI(
            encrypt.encrypt(form.registerPassword)
          )

          var registerData = {
            firstName: '',
            lastName: '',
            middleName: '',
            email: form.email,
            customerLoginPwd: form.registerPassword,
            validCode: form.SMSVerificationCode
          }

          var referrerCode = this.$route.query.referrer
          if (referrerCode) {
            registerData.referrer = referrerCode
          }

          api
            .userRegister(registerData)
            .then(res => {
              this.isRegistering = false
              if (Number(res.data.code) == 0) {

                // hubspot create new contact
                this.createOrUpdateHubspotContact('true');

                var data = res.data.data
                var str = data.crmCustomerLoginName
                if (str.indexOf('+1') >= 0) {
                  data.crmCustomerLoginName = str.slice(2)
                }
                Cookie.set(
                  'userData',
                  encodeURIComponent(JSON.stringify(data))
                )
                Cookie.set('customerId', data.crmCustomerId)
                _this.setUserInfo(data)
                /*
																api.mgxyApply({
																		tokenId: this.userInfo.token,
																		frontApplyMoney:0,
																		frontApplyExpires:0,
																		frontApplyExpiresUnit: 2,
																		frontApplyProductId: '10000057600012'
																}).then((res)=>{
																		console.log(res)
																		var data = res.data;
																		this.isLoading = false;
																		if(data.code == 0){
																			localStorage.setItem('$applyId', data.result.frontApplyId); // ä¿�å­˜ ç”³è¯·å€Ÿæ¬¾id


																		}else{
																			this.$alert(res.data.msg);
																		}

																	})
									*/
                setTimeout(function () {
                  // _this.$router.push('/personalCenter')
                  // window.location.reload(true);
                  // console.log(_this.products[_this.products]);
                  // console.log(_this.userInfo);
                  //                    _this.$router.push(`/applyLoan/10000055800608/sbl`)
                  //                    window.location.reload(true);
                }, 10)
                this.submitForm()
                return true
              } else {
                if (
                  res.data.result ===
                  'Registration failed, email has been registered'
                ) {
                  alert(res.data.result)
                  _this.$router.push({
                    path: `/login`,
                    query: {
                      applyLoanId: this.$route.query.applyLoanId,
                      isEdit: this.$route.query.isEdit
                    }
                  })
                }
                if (this.isCounting === false) {
                  this.SMSVerificationCodeBtn.disabled = false
                  this.SMSVerificationCodeBtn.text =
                    'get email verification code'
                  clearInterval(this.countDown)
                } else {
                  alert(res.data.result)
                }
                return false
              }
            })
        } else {
          setTimeout(() => {
            placeholders.placeHolder(this)
          }, 30)
          return false
        }
      })
    },

    createOrUpdateHubspotContact (applied) {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'applied_successfully', value: applied },
        { property: 'website_new_apply_tag', value: 'Website new leads' }
      ];

      var appliedProduct = '';
      if (this.ctlForm.product === '10000057823975') {
        appliedProduct = 'SBEL_product';
      }
      if (this.ctlForm.product === '10000057880003') {
        appliedProduct = 'SBIF_product';
      }
      if(appliedProduct != '') {
        dataProperties.push({ property: 'applied_product', value: appliedProduct });
      }

      if(_this.ctlForm.amount != '') {
        dataProperties.push({ property: 'deal_amount', value: _this.ctlForm.amount });
      }

      if(_this.ctlForm.term != '') {
        dataProperties.push({ property: 'deal_loan_term', value: _this.ctlForm.term });
      }

      console.log(dataProperties)

      const body = {
        email: _this.ctlForm.email,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },

    submitForm () {
      var _this = this
      this.$refs.ctlForm.validate(valid => {
        if (valid) {
          this.isLoading = true
          var frontApplyProductId, frontApplyExpiresUnit
          if (this.ctlForm.product === '10000057823975') {
            frontApplyProductId = 10000057823975
            frontApplyExpiresUnit = 2
          }
          if (this.ctlForm.product === '10000057880003') {
            frontApplyProductId = 10000057880003
            frontApplyExpiresUnit = 3
          }

          localStorage.setItem('$appliedProductId', frontApplyProductId)

          api
            .mgxyApply({
              frontApplyProductId: frontApplyProductId,
              tokenId: _this.userInfo.token,
              frontApplyMoney: _this.ctlForm.amount,
              frontApplyExpires: _this.ctlForm.term,
              frontApplyExpiresUnit: frontApplyExpiresUnit,
              frontInformationSources: '5'
            })
            .then(res => {
              console.log(res)
              var _data = res.data
              if (_data.code == 0) {
                localStorage.setItem('$applyId', _data.result.frontApplyId)
                this.complete()
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                })

                _this.$router.push({
                  path: `/personalCenter/BusinessInfo`
                })
              }
            })
        }
      })
    },

    complete () {
      api
        .postForm(
          '/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht',
          {
            tokenId: this.userInfo.token,
            frontApplyId: localStorage.getItem('$applyId')
          }
        )
        .then(res => {
          this.isLoading = false
          this.$router.push({
            path: `/applyLoan/${localStorage.getItem('$applyId')}/sbl01`,
            query: {
              applyLoanId: this.$route.query.applyLoanId,
              isEdit: this.$route.query.isEdit
            }
          })
        })
    }
  }, //end of methods

  showRegisterContract () {
    this.setRegisterContract({
      show: true
    })
  },

  mounted () {
    this.getRegisterContract()
    this.getGenerateRSAPublicKey().then(res => {
      this.publicKey = res.data.publicKey
    })
    this.getMgxyDictionary()

    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }

    var keywords = document.getElementById('seokeywords')
    if (!keywords) {
      keywords = document.createElement('meta')
      keywords.name = 'keywords'
      keywords.id = 'seokeywords'
      document.head.insertBefore(keywords, seo)
    }

    document.title = 'Apply Now - Quick & Simple Application | American Credit'
    meta.content = 'Quick & Simple Business Loan Application. Up to $5 Million. Apply for your Asset-Based business loan or Invoice Financing. Apply online, or Cal Us anytime!'
    keywords.content = 'Small Business Loan Qualifying, unsecured business loan, small business loan application, american credit'
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1440px;
}

.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step-form__form {
  width: 100%;
}

.consultant-name {
  font-size: 20px;
  color: #000088;
  text-align: center;
}

.consultant-quote {
  font-size: 18px;
  line-height: 30px;
  color: #696969;
}

.phone-info {
  color: #696969;
}

.phone-info a {
  color: #5456FF;
}

.phone-icon {
  color: #5456FF;
}

.social-media {
  margin-bottom: 40px;

  @media (min-width: 992px) {
    margin-bottom: 108px;
  }
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.step-text-active {
  font-weight: 700;
  color: #009dd9;
  border-bottom: 2px solid #009dd9;
}

.step-text {
  font-weight: 700;
  color: #009dd9;
  text-align: center;
  width: 300px;
}
</style>

<style lang="scss">
  .custom-el-option {
    padding: 8px 10px !important;
  }

  .el-input .el-input__inner {
    color: #1f2d3d;
  }

  .step-form__main .el-col-16{
  	width:100%;
  	text-align:center;
  }

  .step-form__main .step-form__form .el-form-item__label{
  	width: 100%;
    text-align: left;
    display: block;
    color:#393939;
  }

  .step-form__main .step-form__form .el-form-item__content{
  	margin-left:0!important;  
  }
</style>



// WEBPACK FOOTER //
// Register.vue?88f0012e